import React from "react";
import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  ISaveProductVersion,
  SaveProductVersion,
  SaveResponse,
} from "services/KnowfullyAdminClient";

import ProductVersionForm from "./ProductVersionForm";

type ProductVersionCreateFormProps = {
  onProductVersionCreated: (id: string) => void;
  onCancel: () => void;
};

const ProductVersionCreateForm = ({
  onProductVersionCreated,
  onCancel,
}: ProductVersionCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { productService } = useGlobalContext();

  const onSubmit = (values: ISaveProductVersion) => {
    return registerPromise(
      productService.saveProductVersion(new SaveProductVersion(values))
    )
      .then(({ id }: SaveResponse) => {
        onProductVersionCreated(id!);
      })
      .catch((err: any) => {
        console.log(err);
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ProductVersionForm
      onSubmit={onSubmit}
      submitLabel={t({ id: "productVersionCreateButton" })}
      onCancel={onCancel}
    />
  );
};

export default ProductVersionCreateForm;
